import React, { useState } from "react";
import { Menu } from "lucide-react";
import ModuleSideNav from "./ModuleSideNav";

const ModuleLayout = ({ moduleKey, children }) => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="w-full max-w-[1800px] mx-auto px-3 sm:px-4 md:px-6 py-3 sm:py-4 md:py-6">
      <div className="flex flex-col md:flex-row gap-3 sm:gap-4 md:gap-6">
        <ModuleSideNav
          moduleKey={moduleKey}
          isMobileOpen={mobileNavOpen}
          onMobileClose={() => setMobileNavOpen(false)}
        />
        <div className="flex-1 min-w-0">{children}</div>
      </div>

      {/* Mobile menu button */}
      <button
        type="button"
        className="mobile-menu-btn"
        onClick={() => setMobileNavOpen(true)}
        aria-label="Open navigation menu"
        aria-expanded={mobileNavOpen}
      >
        <Menu className="h-6 w-6" />
      </button>
    </div>
  );
};

export default ModuleLayout;
